module.exports = __webpack_public_path__ + "img/Roadmap_Flowers.0b1ff97c.png";